import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import SVGDownload from "components/_common/icons/vdm/SVGDownload";
import OperationLogsTable from "./_elements/OperationLogsTable";

type OwnProps = {
	vesselId: string;
};
type VDMDashboardSecurityProps = PropsFromRedux & OwnProps;
function VDMDashboardSecurity(props: VDMDashboardSecurityProps) {
	return (
		<div className="mt-4">
			<div className="flex items-center justify-between">
				<h4 className="text-base text-gray-800 font-medium">
					Security Operations Log
				</h4>
				<div className="p-1 border rounded border-gray-300 cursor-pointer">
					<SVGDownload />
				</div>
			</div>
			<OperationLogsTable />
		</div>
	);
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardSecurity);
